import PageContainer from '@Guidelines/Layout/PageContainer';
import DocumentGroupEditContent from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/DocumentGroupEditContent';
import DocumentGroupsNotifications from '@UI/Pages/Administration/DocumentGroups/Shared/DocumentGroupsNotifications';
import type * as React from 'react';

/**
 * Assembles the editor screen for both routes: `/administration/document-groups/new` composes a new
 * group, `/administration/document-groups/:workflowKey` edits an existing one.
 */
const DocumentGroupEditPage: React.FC = () => {
	return (
		<PageContainer width="md">
			<DocumentGroupEditContent />
			<DocumentGroupsNotifications />
		</PageContainer>
	);
};

export default DocumentGroupEditPage;
